import * as React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { callApi } from '../helpers/axios_helper';
import { getUser, login, logout } from '../helpers/auth_helper';
import BreadCrumb from '../ass_components/BreadCrumb'
import Meta from '../ass_components/Meta'
import { RiAccountCircleFill } from "react-icons/ri";
import { Link } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import DownloadQRCodeSlide from "../ass_components/DownloadQRCodeSlide";
import {connect} from 'react-redux';
import { loginSuccess, clearPendingAction, closeLoginModal } from '../store/reducers/authSlice';
import { loginApi } from "../servics/authApi";
import { googleLoginApi } from "../servics/authApi";
import { fetchTenantById } from "../store/reducers/tenantSlice";
import { fetchTenantUserById } from "../store/reducers/tenantUserSlice";
import {withNavigation} from "../helpers/withNavigation";
import PropTypes from "prop-types";
import { CHANGE_PASSWORD_PATH } from "../utils/passwordPolicy";

class Login extends React.Component {

  constructor(props) {
       
    super(props);
    this.state = { user: {}, 
                   api: "", 
                   buyer:false, 
                   seller:false, 
                   clicked:false, 
                   errorMessage: '',
                   tenantCode: ""};
    this.shouldCancel = true;
    this.buyer= false;
  }

    parseJwt = (token) => {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            console.error("Erreur décodage JWT", e);
            return null;
        }
    };

  handleTenantChange = (event) => {
    this.setState({ tenantCode: event.target.value });
  };



    handleSuccess = async (
        credentialResponse
    ) => {

        const googleJwt =
            credentialResponse.credential;

        const { tenantCode } =
            this.state;


        if (!tenantCode) {

            alert(
                "Veuillez sélectionner un tenant."
            );

            return;
        }


        const countryCode =
            this.props.country?.value;


        if (!countryCode) {

            alert(
                "Le pays courant n'est pas défini."
            );

            return;
        }


        try {

            const response =
                await googleLoginApi(
                    googleJwt,
                    tenantCode,
                    countryCode
                );


            const data =
                response.data;


            this.handleLoginSuccess(
                data
            );


            window.location.href =
                "http://localhost:3002";


        } catch (err) {

            console.error(
                "❌ Erreur Google Login :",
                err
            );
        }
    };

    handleLoginSuccess = (userData) => {

        const {
            pendingAction,
            loginSuccess,
            clearPendingAction,
            closeLoginModal,
            fetchTenantById,
            fetchTenantUserById
        } = this.props;


        /*
         * ==========================
         * AUTH
         * ==========================
         */

        loginSuccess(
            userData
        );


        /*
         * ==========================
         * PERSISTENCE
         * ==========================
         */

        if (userData.token) {

            localStorage.setItem(
                "token",
                userData.token
            );
        }


        localStorage.setItem(
            "user",
            JSON.stringify(userData)
        );


        /*
         * ==========================
         * COUNTRY
         * ==========================
         */

        if (userData.country_code) {

            localStorage.setItem(
                "country_code",
                userData.country_code
            );
        }


        /*
         * ==========================
         * TENANT
         * ==========================
         */

        if (userData.tenant_code) {

            localStorage.setItem(
                "tenantCode",
                userData.tenant_code
            );
        }


        /*
         * ==========================
         * TENANT DATA
         * ==========================
         */

        if (userData.tenant_id) {

            fetchTenantById(
                userData.tenant_id
            );
        }


        /*
         * ==========================
         * TENANT USER
         * ==========================
         */

        if (userData.email) {

            fetchTenantUserById(
                userData.email
            );
        }


        /*
         * ==========================
         * LOGIN MODAL
         * ==========================
         */

        closeLoginModal();


        /*
         * ==========================
         * PENDING ACTION
         * ==========================
         */

        if (
            pendingAction?.actionFn
        ) {

            pendingAction.actionFn();

            clearPendingAction();
        }
    };


    handleError = () => {
    console.error("❌ Échec de la connexion Google");
  };

  seller = false;
  buyer = false;
  clickedSeller = false;
  clickedBuyer = false;

  setBuyer = () => {
    this.buyer = !this.buyer;
    this.clickedBuyer = !this.clickedBuyer;
    this.forceUpdate();
 }
 setSeller = () => {
    this.seller = !this.seller;
    this.clickedSeller = !this.clickedSeller;
    this.forceUpdate();
 }
  componentDidMount() {
      this.getUser();
  }

    nonCompanyLogin = async () => {

        const email =
            document.getElementById(
                'nonCompanyEmail'
            ).value;

        const password =
            document.getElementById(
                'nonCompanyPassword'
            ).value;


        const tenantCode =
            'non_company';


        const countryCode =
            this.props.country?.value;


        if (!countryCode) {

            this.setState({
                errorMessage:
                    "Le pays courant n'est pas défini."
            });

            return;
        }


        try {

            const response =
                await loginApi(
                    email,
                    password,
                    tenantCode,
                    countryCode
                );


            const data =
                response.data;


            const decoded =
                this.parseJwt(
                    data.token
                );


            const userData = {

                ...decoded,

                token: data.token

            };


            this.handleLoginSuccess(
                userData
            );


            // Mot de passe reçu par email jamais changé : d'abord la page de changement.
            this.props.navigate(
                data.passwordChangeRequired || decoded?.password_change_required
                    ? `${CHANGE_PASSWORD_PATH}?redirect=${encodeURIComponent("/account")}`
                    : "/account"
            );


        } catch (err) {

            console.error(err);

            this.setState({

                errorMessage:
                    err.response?.data?.message ||
                    err.message

            });
        }
    };

    companyLogin = async () => {

        const email =
            document.getElementById(
                'companyEmail'
            ).value;

        const password =
            document.getElementById(
                'companyPassword'
            ).value;

        const tenantCode =
            document.getElementById(
                'tenantcode'
            ).value;


        const countryCode =
            this.props.country?.value;


        if (!countryCode) {

            this.setState({
                errorMessage:
                    "Le pays courant n'est pas défini."
            });

            return;
        }


        try {

            console.log(
                "🌍 Login country =",
                countryCode
            );

            console.log(
                "🏢 Login tenant =",
                tenantCode
            );


            const response =
                await loginApi(
                    email,
                    password,
                    tenantCode,
                    countryCode
                );


            const data =
                response.data;


            const decoded =
                this.parseJwt(data.token);


            const userData = {

                ...decoded,

                token: data.token
            };


            /*
             * Persistence
             */
            localStorage.setItem(
                "token",
                data.token
            );

            localStorage.setItem(
                "user",
                JSON.stringify(userData)
            );


            /*
             * IMPORTANT :
             * on utilise le country_code du JWT
             * comme source de vérité après login.
             */
            if (decoded?.country_code) {

                localStorage.setItem(
                    "country_code",
                    decoded.country_code
                );
            }


            if (decoded?.tenant_code) {

                localStorage.setItem(
                    "tenantCode",
                    decoded.tenant_code
                );
            }


            /*
             * Redux
             */
            this.handleLoginSuccess(
                userData
            );


            // Mot de passe reçu par email jamais changé : d'abord la page de changement.
            this.props.navigate(
                data.passwordChangeRequired || decoded?.password_change_required
                    ? `${CHANGE_PASSWORD_PATH}?redirect=${encodeURIComponent("/account")}`
                    : "/account"
            );


        } catch (err) {

            console.error(
                "❌ Erreur login entreprise :",
                err
            );

            this.setState({

                errorMessage:
                    err.response?.data?.message ||
                    err.message

            });
        }
    };


    callApi = () => {
      callApi()
          .then(response => {
              this.setState({ api: response.data });
              toast.success('Api return successfully data, check in section - Api response');
          })
          .catch(error => {
              toast.error(error);
          });
  };

  componentWillUnmount() {
      this.shouldCancel = true;
  }

  logout = () => {
      logout();
  };

  getUser = () => {
      getUser().then(user => {
          // if (user) {
          //     toast.success('User has been successfully loaded from store.');
          // } else {
          //     toast.info('You are not logged in.');
          // }

          if (!this.shouldCancel) {
              this.setState({ user });
          }
      });
  };

render() {
   
  return (
    <>
    <Meta title={"Login"}/>
    <BreadCrumb title='Page de connexion'/>
    <div className='wishlist-wrapper assiganto-home-wrapper-2 py-3'>
    <div className='container-xxl'>
      <div className='row'>
          <div className='col-12'>
            <div className='d-flex flex-column full-auth-card py-2'>
              <div className='login-header d-flex'>
                <div className='login-picto'>
                <img src="images/core_images/assiganto-picto.png" 
                    className="img-fluid" 
                    alt="small-banner"/>
                </div>
                <div className='login-header-signup'>
                    <RiAccountCircleFill className='header-options-icons' to='/signup'/>
                    <Link to='/signup' className='login-header-singnup-text'>S'inscrire</Link>
                </div>
              </div>
              <div className='d-flex login-space py-4'>
              <div className='login-form'>
              <h5 className="text-start mb-3" >SE CONNECTER</h5>
              <form action="" className="d-flex flex-column gap-15" >
              {((!this.buyer && !this.clickedSeller) || (this.buyer))?
                <div className="radio-box form-check pt-2">
                  <input className="form-check-input" type='checkbox' value='' id='' onClick={this.setBuyer}/>
                  <label className="form-check-label" htmlFor="">
                  Connection compte entrepise
                  </label>
                  <p className='small-text'>Compte qui vous permet de suivre vos productions.</p>
                </div>:
                <div></div>
                }
                
                {((!this.seller && !this.clickedBuyer) || (this.seller))?
                <div className="radio-box form-check pt-2 mr-4">
                  <input className="form-check-input" type='checkbox' value='' id='' onClick={this.setSeller}/>
                  <label className="form-check-label" htmlFor="">
                  Connection compte particulier
                  </label>
                  <p className='small-text'>Compte qui vous permet de vendre vos produits</p>
                </div>:
                <div></div>
                }
        {this.buyer ?
        <div>
            {this.state.errorMessage && (
                <div style={{ color: 'red', marginBottom: '10px' }}>
                {this.state.errorMessage}
                </div>
            )}  <div className="flex-col">
                    <label htmlFor="tenantCode">Agro Code</label>
                    <input
                    type="text"
                    id="tenantcode"
                    name="tenantcode"
                    placeholder="Code entreprise"
                    required
                    />
                </div>
                <div className="flex-col">
                    <label htmlFor="companyEmail">Email</label>
                    <input
                        type="email"
                        id="companyEmail"
                        name="billFirstName"
                        placeholder="Email du compte entreprise"
                        required 
                    />
                </div>
                <div className="flex-col">
                    <label htmlFor="companyPassword">Mot de Passe</label>
                    <input
                    type="password"
                    id="companyPassword"
                    name="companyPassword"
                    placeholder="Mot de passe"
                    pattern=".{6,}"  // Accept any password with at least 6 characters
                    title="Password must be at least 6 characters long"
                    />
                </div>
            <div>
            <Link to='/forgot-password' className='small-text mt-2'>Mot de passe oublié ?</Link>
            <div className="mt-3 d-flex align-items-center justify-content-center gap-15">
                <button className="button" onClick={this.companyLogin} type="button">Login</button>
            </div>
            </div>
        </div> :
        <div></div>}
        {!this.seller && !this.buyer && !this.clickedBuyer && !this.clickedseller  ?
          <div className='d-flex flex-column align-items-center justify-content-center'>
            <h6>ou</h6>

            <input
              type="text"
              value={this.state.tenantCode}
              onChange={this.handleTenantChange}
              className="form-control mb-3"
              style={{ width: "300px" }}
              placeholder="Entrez votre Agro Code"
            />

            <GoogleLogin
                onSuccess={this.handleSuccess}
                onError={this.handleError}
                width="300"          // 👈 Set width directly here
                size="large"         // 👈 Set size: small | medium | large
                theme="filled_blue"  // 👈 Optional: looks nicer
                text="signin_with"   // 👈 Optional: changes button text
                shape="pill"         // 👈 Optional: rounded button
            />
          </div>
            :<div></div> 
        }
        {this.seller ?
        <div>
                <div className="flex-col">
                    <label htmlFor="nonCompanyEmail">Email</label>
                    <input
                        type="email"
                        id="nonCompanyEmail"
                        name="nonCompanyEmail"
                        placeholder="Email du compte entreprise"
                        required 
                    />
                </div>
                <div className="flex-col">
                    <label htmlFor="nonCompanyPassword">Mot de Passe</label>
                    <input
                    type="password"
                    id="nonCompanyPassword"
                    name="nonCompanyPassword"
                    placeholder="Mot de passe"
                    pattern=".{6,}"  // Accept any password with at least 6 characters
                    title="Password must be at least 6 characters long"
                    />
                </div>
            <div>
            <Link to='/forgot-password' className='small-text'>Mot de passe oublié ?</Link>
            <div className="mt-3 d-flex align-items-center justify-content-center gap-15">
                <button className="button" onClick={this.nonCompanyLogin} type="button">Login</button>
            </div>
            </div>
        </div> :
        
            <div>
               
            </div>
           
        }
               
              </form>
                </div>
                  <div className='non_company-pub w-100'>
                      <div id="carouselDownload" className="carousel slide" data-bs-ride="carousel" data-bs-interval="6000">

                          <div className="carousel-inner">

                              {/* Slide 1 : image */}
                              <div className="carousel-item active">
                                  <img
                                      src='images/assiganto-pub-svg/agro.png'
                                      className='d-block w-100 img-fluid pub-image'
                                      alt='Promotion'
                                  />
                              </div>

                              {/* Slide 2 : QR code */}
                              <div className="carousel-item">
                                  <DownloadQRCodeSlide />
                              </div>

                          </div>

                          {/* Optionnel : contrôles du carousel */}
                          <button className="carousel-control-prev" type="button" data-bs-target="#carouselDownload" data-bs-slide="prev">
                              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                              <span className="visually-hidden">Précédent</span>
                          </button>
                          <button className="carousel-control-next" type="button" data-bs-target="#carouselDownload" data-bs-slide="next">
                              <span className="carousel-control-next-icon" aria-hidden="true"></span>
                              <span className="visually-hidden">Suivant</span>
                          </button>
                      </div>
                  </div>
              </div>

            </div>
          </div>
        </div>
      </div>
        
    </div>
    </>
  )
}
}

// 1️⃣ mapStateToProps : mappe les states Redux au props
const mapStateToProps = (state) => ({

    pendingAction:
    state.auth.pendingAction,

    loginModalOpen:
    state.auth.loginModalOpen,

    isAuthenticated:
    state.auth.isAuthenticated,

    country:
    state.country.country

});

// 2️⃣ mapDispatchToProps : mappe les actions Redux au props
const mapDispatchToProps = {
    loginSuccess,
    clearPendingAction,
    closeLoginModal,
    fetchTenantById,
    fetchTenantUserById// 👈 AJOUT
};

Login.propTypes = {
    navigate: PropTypes.func.isRequired,
    loginSuccess: PropTypes.func.isRequired,
    clearPendingAction: PropTypes.func.isRequired,
    closeLoginModal: PropTypes.func.isRequired,
    fetchTenantById: PropTypes.func.isRequired,
    fetchTenantUserById: PropTypes.func.isRequired,
    pendingAction: PropTypes.object
};

// 3️⃣ connect la classe au store
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNavigation(Login));


